import { ModuleManifest } from "shared/bootstrap";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "home" },
      title: "global.terms.home",
      icon: "home",
      hideNoAuth: true,
      top: true,
    },
  ],
  routes: [
    {
      path: "/",
      redirect: { name: "home" },
      meta: {
        auth: true,
      },
    },
    {
      path: "/home",
      name: "home",
      meta: {
        auth: true,
      },
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      component: () => import("./pages/Home.vue"),
    },
  ],
};

export default manifest;
